import { CountryEnum } from "Infrastructure/Api/Api";
import { z } from "zod";
import { buildingNumberSchema } from "./common";

export const getPartnerAddressInfoEditSchema = () => {
	return z.object({
		street: z.string().nullish(),
		buildingNumber: buildingNumberSchema(10),
		postCode: z.string().nullish(),
		city: z.string().nullish(),
		country: z.nativeEnum(CountryEnum).nullish(),
	});
};

export type PartnerAddressInfoEditFormModel = z.infer<
	ReturnType<typeof getPartnerAddressInfoEditSchema>
>;
